export default __webpack_public_path__ + "static/kv-logo-m-jp-9e8c9016dde0aeb199f22e0e75a7ad18.png";